module.exports = __webpack_public_path__ + "static/step6-94ebfcf428a3532614ecc9208dd16d72.svg";